import React from 'react';

export const LoggerContext = React.createContext();

LoggerContext.displayName = 'LoggerContext';

export const LoggerContextProvider = LoggerContext.Provider;
export const LoggerContextConsumer = LoggerContext.Consumer;

export default LoggerContext;
